
export const createRectFromCenter = (center, size) => ({
    ...size,
    x: center.x - size.width  / 2,
    y: center.y - size.height / 2,
});
